import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Chip,
  Divider,
  Grid,
  Link,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Modal,
  Stack,
  Switch,
  Typography,
  useTheme,
} from "@mui/material";
import {
  listHotelProfile,
  resetHotelProfile,
  updateHotelProfile,
} from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import BasicInfo from "../registration/basicInfo";
import PropertyInfo from "../registration/propertyInfo";
import { Close, Edit, Key, KeyboardArrowDown } from "@mui/icons-material";
import ChangePassword from "./changePassword";
import { toast } from "react-toastify";
import ImagePreviewDialog from "../../components/ImagePreviewDialog";
import { EditableInvoiceSeriesAccordion } from "./InvoiceSeriesAccordion";

function Profile() {
  const dispatch = useDispatch();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [updation, setUpdation] = useState(false);
  const [basicInfoData, setBasicInfoData] = useState({});
  const [propInfoData, setPropInfoData] = useState({});
  const [contactData, setContactData] = useState({ name: "" });

  const [showModdal, setShowModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openImage, setOpenImage] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { sm: 400, xs: "90%" },
    bgcolor: colors.primary[400],
    outline: "none",
    boxShadow: 24,
    p: 2,
  };
  const imageBoxStyle = {
    container: {
      position: "relative",
      width: "30%",
      borderRadius: 2,
      overflow: "hidden",
      cursor: "pointer",
      "&:hover .hover-text": {
        opacity: 1,
        transform: "translate(-50%, -50%) scale(1)",
      },
      "&:hover img": { filter: "brightness(70%)" },
    },
    image: {
      width: "100%",
      height: "auto",
      display: "block",
      borderRadius: "8px",
      transition: "filter 0.3s ease",
    },
    hoverText: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%) scale(0.9)",
      color: "#fff",
      fontSize: "14px",
      fontWeight: 500,
      background: "rgba(0,0,0,0.6)",
      padding: "6px 12px",
      borderRadius: "6px",
      opacity: 0,
      whiteSpace: "nowrap",
      textAlign: "center",
      transition: "all 0.3s ease",
    },
  };

  const { isLoading, hotelProfile } = useSelector(
    ({ loading, registration: { hotelProfile } }) => ({
      isLoading: loading,
      hotelProfile,
    })
  );
  const {
    title,
    first_name,
    last_name,
    email,
    address1,
    address2,
    phone,
    mobile,
    city,
    country,
    state,
    postal_code,
    fax,
    property,
    slug,
    logo,
    hotel_img,
    // cancel_policy,
    min_child_age,
    max_child_age,
    contact_person,
    gstin,
    gst_enabled,
    billing_enabled,
    bank_details,
    bke_discount,
    bke_partial_pmt,
    // flexible_occupancy,
    cautions,
    house_rules,
    // cancellation_policy,
    guest_checkin_time,
    guest_checkout_time,
    guest_reporting_time,
    guest_cruise_start_time,
    cin,
    pan,
  } = hotelProfile;

  useEffect(() => {
    document.title = "Profile";
    dispatch(resetHotelProfile());
    dispatch(listHotelProfile());
    setBasicInfoData(hotelProfile);
    if (hotelProfile?.property) {
      setPropInfoData(hotelProfile?.property);
    }
    if (hotelProfile?.contact_person) {
      setContactData(hotelProfile?.contact_person);
    }
    // eslint-disable-next-line
  }, [dispatch]);

  const handleProfileSubmit = async () => {
    console.log(basicInfoData);
    let res = await dispatch(updateHotelProfile(basicInfoData));
    if (res) toast.success("Data updated successfully");
  };

  const handlePropertySubmit = async () => {
    if (propInfoData?.type === null) {
      propInfoData.type = "Hotel";
    }
    if (propInfoData?.country === null) {
      propInfoData.country = "IN";
    }
    if (propInfoData?.state === null) {
      propInfoData.state = "Kerala";
    }
    const categoryId = basicInfoData?.category_id?._id || basicInfoData?.category_id;
    let data = {
      ...basicInfoData,
      name: propInfoData.name,
      property: propInfoData,
      contact_person: contactData,
      ...(categoryId ? { category_id: categoryId } : {}),
    };
    let res = await dispatch(updateHotelProfile(data));
    if (res) toast.success("Data updated successfully");
    // handleProfileSubmit();
  };

  const FieldAndValue = ({ field, value, sx = {} }) => (
    <Stack direction="row" spacing={2} sx={sx}>
      <Typography width={"40%"}>{field}:</Typography>
      <Typography>{value}</Typography>
    </Stack>
  );

  return (
    <Box m="20px" mb={15}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Header title="PROFILE" subtitle="welcome to Profile" />
        <Button
          size="small"
          variant="outlined"
          endIcon={updation ? <Close /> : <KeyboardArrowDown />}
          onClick={updation ? () => setUpdation(false) : handleMenuClick}
        >
          {updation ? <b>Close</b> : <b>Options</b>}
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={openMenu}
          onClose={handleMenuClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem
            onClick={() => {
              setUpdation(true);
              handleMenuClose();
            }}
          >
            <ListItemIcon>
              <Edit fontSize="small" />
            </ListItemIcon>
            <ListItemText>Update Profile</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={() => {
              setShowModal(true);
              handleMenuClose();
            }}
          >
            <ListItemIcon>
              <Key fontSize="small" />
            </ListItemIcon>
            <ListItemText>Change Password</ListItemText>
          </MenuItem>
        </Menu>
      </Stack>
      <Box
        width="100%"
        p={2}
        borderRadius={1}
        backgroundColor={colors.primary[400]}
      >
        {updation ? (
          <Stack spacing={2}>
            <Typography
              variant="h4"
              fontWeight="bold"
              color={colors.greenAccent[500]}
            >
              USER INFO
            </Typography>
            <BasicInfo
              basicInfoData={basicInfoData}
              setBasicInfoData={setBasicInfoData}
              handleProfileSubmit={handleProfileSubmit}
            />
            <br />
            <Typography
              variant="h4"
              fontWeight="bold"
              color={colors.greenAccent[500]}
            >
              PROPERTY INFO
            </Typography>
            <PropertyInfo
              propInfoData={propInfoData}
              setPropInfoData={setPropInfoData}
              contactData={contactData}
              setContactData={setContactData}
              basicInfoData={basicInfoData}
              setBasicInfoData={setBasicInfoData}
              handlePropertySubmit={handlePropertySubmit}
            />
          </Stack>
        ) : (
          <Grid container spacing={{ md: 4, xs: 2 }}>
            <Grid item md={6} xs={12}>
              <Stack spacing={2}>
                <Typography
                  variant="h4"
                  fontWeight="bold"
                  color={colors.greenAccent[500]}
                >
                  USER INFO
                </Typography>
                <Stack direction="row" spacing={2}>
                  <Typography width={"40%"}>Name:</Typography>
                  <Typography sx={{ textTransform: "capitalize" }}>
                    {title || ""} {first_name || "-"} {last_name || ""}
                  </Typography>
                </Stack>
                <FieldAndValue field={"Email"} value={email || "-"} />
                <FieldAndValue field={"Mobile"} value={mobile || "-"} />
                <FieldAndValue field={"Phone"} value={phone || "-"} />
                <Stack direction="row" spacing={2}>
                  <Typography width={"40%"}>Address:</Typography>
                  <Stack>
                    <Typography>{address1 || "-"}</Typography>
                    <Typography>{address2 || ""}</Typography>
                  </Stack>
                </Stack>
                <FieldAndValue field={"City"} value={city || "-"} />
                <FieldAndValue field={"State"} value={state || "-"} />
                <FieldAndValue field={"Country"} value={country || "-"} />
                <FieldAndValue
                  field={"Postal code"}
                  value={postal_code || "-"}
                />
                <FieldAndValue field={"Fax"} value={fax || "-"} />
                <Divider />
                <Typography
                  variant="h4"
                  fontWeight={600}
                  color={colors.greenAccent[600]}
                >
                  Account details
                </Typography>
                <FieldAndValue
                  field={"A/c hoder name"}
                  value={bank_details?.acc_holder_name || "-"}
                />
                <FieldAndValue
                  field={"A/c no"}
                  value={bank_details?.acc_no || "-"}
                />
                <FieldAndValue
                  field={"IFSC code"}
                  value={bank_details?.ifsc || "-"}
                />
                <FieldAndValue
                  field={"A/c type"}
                  value={bank_details?.acc_type || "-"}
                />
                <FieldAndValue
                  field={"Bank name"}
                  value={bank_details?.bank_name || "-"}
                />
                <FieldAndValue
                  field={"Branch"}
                  value={bank_details?.branch_name || "-"}
                />
                <FieldAndValue
                  field={"Payment link"}
                  value={bank_details?.payment_link || "-"}
                />
                {basicInfoData?.payment_qr_code_img && (
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={3}
                    sx={{ mb: 3 }}
                  >
                    <Typography width={"40%"}>Payment QR Code:</Typography>
                    <Box
                      sx={imageBoxStyle.container}
                      onClick={() =>
                        setOpenImage(basicInfoData.payment_qr_code_img)
                      }
                    >
                      <img
                        src={basicInfoData.payment_qr_code_img}
                        alt="Payment QR"
                        style={imageBoxStyle.image}
                      />
                      <Typography
                        className="hover-text"
                        sx={imageBoxStyle.hoverText}
                      >
                        View Full Image
                      </Typography>
                    </Box>
                  </Stack>
                )}

                {basicInfoData?.reservation_signature_img && (
                  <Stack direction="row" alignItems="center" spacing={3}>
                    <Typography sx={{ width: "40%", fontWeight: 500 }}>
                      Reservation Signature:
                    </Typography>
                    <Box
                      sx={imageBoxStyle.container}
                      onClick={() =>
                        setOpenImage(basicInfoData.reservation_signature_img)
                      }
                    >
                      <img
                        src={basicInfoData.reservation_signature_img}
                        alt="Signature"
                        style={imageBoxStyle.image}
                      />
                      <Typography
                        className="hover-text"
                        sx={imageBoxStyle.hoverText}
                      >
                        View Full Image
                      </Typography>
                    </Box>
                  </Stack>
                )}
                <FieldAndValue
                  field="GST No"
                  value={
                    <>
                      {gstin || "-"}
                      <span
                        style={{
                          marginLeft: 8,
                          padding: "2px 6px",
                          borderRadius: "4px",
                          background: gst_enabled ? "#DFF6DD" : "#FDE2E2",
                          color: gst_enabled ? "#1A7F37" : "#C62828",
                          fontSize: "12px",
                        }}
                      >
                        {gst_enabled ? "Enabled" : "Disabled"}
                      </span>
                    </>
                  }
                />

                <FieldAndValue field={"PAN"} value={pan || "-"} />
                <FieldAndValue field={"CIN"} value={cin || "-"} />
                <Typography
                  variant="h4"
                  fontWeight={600}
                  color={colors.greenAccent[600]}
                >
                  Booking engine
                </Typography>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Typography width={"40%"}>Show Latest Voucher</Typography>
                  <Switch
                    checked={basicInfoData?.show_latest_voucher || false}
                    disabled
                  />
                </Stack>
                <FieldAndValue
                  field={"Min. child age"}
                  value={min_child_age || "-"}
                />
                <FieldAndValue
                  field={"Max. child age"}
                  value={max_child_age || "-"}
                />
                <FieldAndValue
                  field={"Booking engine discount(%)"}
                  value={bke_discount ? `${bke_discount} %` : "-"}
                />
                {/* <Stack direction="row" spacing={2} >
                                    <Typography width={"40%"}>flexible occupancy:</Typography>
                                        <Switch
                                            disabled
                                            checked={flexible_occupancy ? true : false}
                                        />
                                </Stack> */}
                <FieldAndValue
                  field={"Cautions"}
                  value={cautions?.length ? cautions.join(", ") : "-"}
                />
                <FieldAndValue
                  field={"House rules"}
                  value={house_rules?.length ? house_rules.join(", ") : "-"}
                />
                <FieldAndValue
                  field="Cancellation policy"
                  value={
                    basicInfoData?.show_latest_voucher
                      ? basicInfoData?.cancellation_policy.length
                        ? basicInfoData.cancellation_policy.join(", ")
                        : "-"
                      : basicInfoData?.cancel_policy || "-"
                  }
                />
                <FieldAndValue
                  field={"Guest checkin time"}
                  value={guest_checkin_time || "-"}
                />
                <FieldAndValue
                  field={"Guest checkout time"}
                  value={guest_checkout_time || "-"}
                />
                <FieldAndValue
                  field={"Guest reporting time"}
                  value={guest_reporting_time || "-"}
                />
                <FieldAndValue
                  field={"Guest cruise start time"}
                  value={guest_cruise_start_time || "-"}
                />
                <Stack direction="row" spacing={2}>
                  <Typography width={"40%"}>Partial payment option:</Typography>
                  <Switch disabled checked={bke_partial_pmt ? true : false} />
                </Stack>
                <Stack direction="row" spacing={2}>
                  <Typography width={"40%"}>Url:</Typography>
                  <Link href={`https://hotels.travelnet.in/booking/${slug}`}>
                    {`https://hotels.travelnet.in/booking/${slug}` || "-"}
                  </Link>
                </Stack>
              </Stack>
            </Grid>
            <Grid item md={6} xs={12}>
              <Stack spacing={2}>
                <Typography
                  variant="h4"
                  fontWeight="bold"
                  color={colors.greenAccent[500]}
                >
                  PROPERTY INFO
                </Typography>
                {logo && (
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={3}
                    sx={{ mb: 3 }}
                  >
                    <Typography sx={{ width: "40%", fontWeight: 500 }}>
                      Image for email:
                    </Typography>
                    <Box
                      sx={imageBoxStyle.container}
                      onClick={() => setOpenImage(logo)}
                    >
                      <img src={logo} alt="Logo" style={imageBoxStyle.image} />
                      <Typography
                        className="hover-text"
                        sx={imageBoxStyle.hoverText}
                      >
                        View Full Image
                      </Typography>
                    </Box>
                  </Stack>
                )}

                {hotel_img && (
                  <Stack direction="row" alignItems="center" spacing={3}>
                    <Typography sx={{ width: "40%", fontWeight: 500 }}>
                      Hotel image:
                    </Typography>
                    <Box
                      sx={imageBoxStyle.container}
                      onClick={() => setOpenImage(hotel_img)}
                    >
                      <img
                        src={hotel_img}
                        alt="Hotel"
                        style={imageBoxStyle.image}
                      />
                      <Typography
                        className="hover-text"
                        sx={imageBoxStyle.hoverText}
                      >
                        View Full Image
                      </Typography>
                    </Box>
                  </Stack>
                )}
                <FieldAndValue
                  field={"Name"}
                  value={property?.name || "-"}
                  sx={{ textTransform: "capitalize" }}
                />
                <FieldAndValue field={"Type"} value={property?.type || "-"} />
                <FieldAndValue
                  field={"Address"}
                  value={property?.address || "-"}
                />
                <FieldAndValue
                  field={"Location"}
                  value={property?.location || "-"}
                />
                <FieldAndValue
                  field={"Finance email"}
                  value={property?.finance_email || "-"}
                />
                <FieldAndValue
                  field={"Finance mobile"}
                  value={property?.finance_mobile || "-"}
                />
                {/* <FieldAndValue field={"Reservation email"} value={property?.reservation_email || "-"}/> */}
                <Stack direction="row" spacing={2}>
                  <Typography width={"40%"}>
                    {"Reservation email(s)"}:
                  </Typography>
                  <Stack alignItems="start">
                    {property?.reservation_email
                      ? property?.reservation_email
                          ?.split(",")
                          ?.map((e) => (
                            <Chip label={e} key={e} sx={{ mr: 1, mb: 1 }} />
                          ))
                      : "-"}
                  </Stack>
                </Stack>
                <Stack direction="row" spacing={2}>
                  <Typography width={"40%"}>
                    {"Reservation mobile(s)"}:
                  </Typography>
                  <Stack alignItems="start">
                    {property?.reservation_mobile
                      ? property?.reservation_mobile
                          ?.split(",")
                          ?.map((e) => (
                            <Chip label={e} key={e} sx={{ mr: 1, mb: 1 }} />
                          ))
                      : "-"}
                  </Stack>
                </Stack>
                {/* <FieldAndValue field={"Reservation mobile"} value={property?.reservation_mobile || "-"}/> */}
                <FieldAndValue
                  field={"C-Form Submission Email"}
                  value={property?.c_form_email || "-"}
                />
                <FieldAndValue
                  field={"Land phone"}
                  value={property?.land_phone || "-"}
                />
                {property?.green_hotel?.length ? (
                  <Stack direction="row" spacing={2}>
                    <Typography width={"40%"}>Green Hotel:</Typography>
                    <Stack>
                      {property?.green_hotel?.map((item) => (
                        <Typography key={item}>{item}</Typography>
                      ))}
                    </Stack>
                  </Stack>
                ) : null}
                <FieldAndValue field={"City"} value={property?.city || "-"} />
                <FieldAndValue field={"State"} value={property?.state || "-"} />
                <FieldAndValue
                  field={"Country"}
                  value={property?.country || "-"}
                />
                <FieldAndValue
                  field={"Postal code"}
                  value={property?.postal_code || "-"}
                />
                <FieldAndValue field={"Fax"} value={property?.fax || "-"} />
                <FieldAndValue
                  field={"Category"}
                  value={hotelProfile?.category_id?.name   || "-"}
                />
              </Stack>
              <br />
              <Stack spacing={2}>
                <Typography
                  variant="h4"
                  fontWeight={600}
                  color={colors.greenAccent[600]}
                >
                  Contact Person
                </Typography>
                <FieldAndValue
                  field={"Name"}
                  value={contact_person?.name || "-"}
                />
                <FieldAndValue
                  field={"Email"}
                  value={contact_person?.email || "-"}
                />
                <FieldAndValue
                  field={"Mobile"}
                  value={contact_person?.mobile || "-"}
                />
                <FieldAndValue
                  field={"Phone"}
                  value={contact_person?.phone || "-"}
                />
                <FieldAndValue
                  field={"Designation"}
                  value={contact_person?.designation || "-"}
                />
                <FieldAndValue
                  field={"Address"}
                  value={contact_person?.address || "-"}
                />
              </Stack>
              <EditableInvoiceSeriesAccordion
                hotelId={hotelProfile?._id}
                colors={colors}
                gstEnabled={gst_enabled}
                billingEnabled={billing_enabled}
              />
            </Grid>
            <Grid item xs={12}>
              <Stack spacing={2}>
                {/* <Divider />
                                    <Stack direction="row" spacing={2}>
                                        <Typography sx={{whiteSpace: "nowrap"}} width={"40%"}>Cancellation policy :</Typography>
                                        <Typography>{cancel_policy || "-"}</Typography>
                                    </Stack> */}
                {/* <FieldAndValue field={"Cancellation policy"} value={cancel_policy || "-"} /> */}
              </Stack>
            </Grid>
          </Grid>
        )}
      </Box>

      <Modal open={showModdal} onClose={() => setShowModal(false)}>
        <Box sx={modalStyle}>
          <ChangePassword
            dispatch={dispatch}
            isLoading={isLoading}
            setShowModal={setShowModal}
          />
        </Box>
      </Modal>
      <ImagePreviewDialog
        openImage={openImage}
        onClose={() => setOpenImage(null)}
      />
    </Box>
  );
}

export default Profile;
